import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Row, Col, CustomInput, Card } from "reactstrap";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import { updateCreateParams } from "../../../actions/create";
import CollapsePlusMinus from "../../../components/CollapsePlusMinus/CollapsePlusMinus";
import ErrorAlert from "../../../components/Modals/ErrorAlert";
import { cloneDeep } from "lodash";

export const PhotovoltaicParams = (props) => {
  const [rowDataParams, setRowDataParams] = useState(null);
  const [rowDataParamsFin, setRowDataParamsFin] = useState(null);
  const rowHeight = 24;

  useEffect(() => {
    setRowDataParams(props.create.PV_params);
    setRowDataParamsFin(props.create.PV_paramsFin);
  }, []);

  const obj_PV_axis = {
    irradiance_fixed_zero: "Irradiance Fixed Zero",
    irradiance_fixed_optimal: "Irradiance Fixed Optimal",
    irradiance_inclined_optimal: "Irradiance Inclined Optimal",
    irradiance_two_axis: "Irradiance Two Axis",
  };

  const getCellStyle = (params) => {
    var style = {};
    if (params.colDef.field === "description") {
      style["cursor"] = "not-allowed";
    }
    return style;
  };

  // redux is updated but there is no refresh onChange redux state
  const handleChangeParams = (params) => {
    var regExp = /[a-zA-Z]/g;
    var raise_error = false;
    if (
      params.newValue === "" ||
      params.newValue === undefined ||
      params.newValue === null
    ) {
      params.newValue = 0;
    } else if (
      regExp.test(String(params.newValue)) ||
      String(params.newValue).includes(",") ||
      String(params.newValue).includes(" ")
    ) {
      raise_error = true;
      params.newValue = params.oldValue;
    }
    if (raise_error === true) {
      ErrorAlert(
        "Format not valid! Cannot insert letters, commas or empty spaces"
      );
    } else {
      var newData = cloneDeep(props.create.PV_params);
      newData.forEach((obj) => {
        if (params.data.key === obj.key) {
          obj.value = parseFloat(params.newValue);
        }
      });
      props.updateCreateParams("PV_params", newData);
    }
    return parseFloat(params.newValue);
  };

  // redux is updated but there is no refresh onChange redux state
  const handleChangeParamsFin = (params) => {
    var regExp = /[a-zA-Z]/g;
    var raise_error = false;
    if (
      params.newValue === "" ||
      params.newValue === undefined ||
      params.newValue === null
    ) {
      params.newValue = 0;
    } else if (
      regExp.test(String(params.newValue)) ||
      String(params.newValue).includes(",") ||
      String(params.newValue).includes(" ")
    ) {
      raise_error = true;
      params.newValue = params.oldValue;
    }
    if (raise_error === true) {
      ErrorAlert(
        "Format not valid! Cannot insert letters, commas or empty spaces"
      );
    } else {
      var newData = cloneDeep(props.create.PV_paramsFin);
      newData.forEach((obj) => {
        if (params.data.key === obj.key) {
          obj.value = parseFloat(params.newValue);
        }
      });
      props.updateCreateParams("PV_paramsFin", newData);
    }
    return parseFloat(params.newValue);
  };

  return (
    <div style={{ padding: "10px 20px" }}>
      <div>
        <CustomInput
          type="checkbox"
          id="PV_simulation"
          label="Run Photovoltaic Simulation"
          checked={props.create.PV_run}
          onChange={(e) => props.updateCreateParams("PV_run", e.target.checked)}
        />
      </div>
      {props.create.PV_run ? (
        <div>
          <CollapsePlusMinus title="Mounting Type" opened={true}>
            <Card body>
              <Row>
                {Object.keys(obj_PV_axis).map((axes) => {
                  return (
                    <Col lg="3" md="6" key={axes}>
                      <CustomInput
                        type="checkbox"
                        id={axes}
                        label={obj_PV_axis[axes]}
                        checked={props.create.PV_axes === axes ? true : false}
                        onChange={(e) =>
                          props.updateCreateParams("PV_axes", axes)
                        }
                      />
                    </Col>
                  );
                })}
              </Row>
            </Card>
          </CollapsePlusMinus>
          <CollapsePlusMinus title="PV Parameters" opened={true}>
            <div
              style={{
                width: "55%",
                margin: "0px auto -20px auto",
              }}
              className="ag-theme-balham"
            >
              <AgGridReact
                defaultColDef={{
                  filter: true,
                  sortable: true,
                  resizable: true,
                  minWidth: 60,
                  maxWidth: 600,
                  flex: 1,
                  filterParams: { buttons: ["reset"] },
                  cellStyle: getCellStyle,
                }}
                getContextMenuItems={(params) => [
                  "copy",
                  "copyWithHeaders",
                  "paste",
                  "separator",
                  {
                    name: "Export",
                    icon: '<span class="ag-icon ag-icon-save" unselectable="on" role="presentation"></span>',
                    subMenu: [
                      "csvExport",
                      {
                        name: "Excel Export (.xlsx)",
                        icon: '<span class="ag-icon ag-icon-excel" unselectable="on" role="presentation"></span>',
                        action: () => {
                          params.api.exportDataAsExcel({ sheetName: "Export" });
                        },
                      },
                    ],
                  },
                ]}
                rowData={rowDataParams}
                getRowHeight={(params) => {
                  return rowHeight;
                }}
                domLayout="autoHeight"
                popupParent={document.body}
                suppressDragLeaveHidesColumns={true}
                stopEditingWhenGridLosesFocus={true}
                singleClickEdit={true}
              >
                <AgGridColumn field="description" headerName="Description" />
                <AgGridColumn
                  field="value"
                  headerName="Value"
                  flex={0.25}
                  filter={"agNumberColumnFilter"}
                  type={"numericColumn"}
                  editable={true}
                  valueParser={handleChangeParams}
                />
              </AgGridReact>
            </div>
          </CollapsePlusMinus>
          <CollapsePlusMinus title="PV Financials" opened={true}>
            <div
              style={{
                width: "55%",
                margin: "0px auto -20px auto",
              }}
              className="ag-theme-balham"
            >
              <AgGridReact
                defaultColDef={{
                  filter: true,
                  sortable: true,
                  resizable: true,
                  minWidth: 60,
                  maxWidth: 600,
                  flex: 1,
                  filterParams: { buttons: ["reset"] },
                  cellStyle: getCellStyle,
                }}
                getContextMenuItems={(params) => [
                  "copy",
                  "copyWithHeaders",
                  "paste",
                  "separator",
                  {
                    name: "Export",
                    icon: '<span class="ag-icon ag-icon-save" unselectable="on" role="presentation"></span>',
                    subMenu: [
                      "csvExport",
                      {
                        name: "Excel Export (.xlsx)",
                        icon: '<span class="ag-icon ag-icon-excel" unselectable="on" role="presentation"></span>',
                        action: () => {
                          params.api.exportDataAsExcel({ sheetName: "Export" });
                        },
                      },
                    ],
                  },
                ]}
                rowData={rowDataParamsFin}
                getRowHeight={(params) => {
                  return rowHeight;
                }}
                domLayout="autoHeight"
                popupParent={document.body}
                suppressDragLeaveHidesColumns={true}
                stopEditingWhenGridLosesFocus={true}
                singleClickEdit={true}
              >
                <AgGridColumn field="description" headerName="Description" />
                <AgGridColumn
                  field="value"
                  headerName="Value"
                  flex={0.25}
                  filter={"agNumberColumnFilter"}
                  type={"numericColumn"}
                  editable={true}
                  valueParser={handleChangeParamsFin}
                />
              </AgGridReact>
            </div>
          </CollapsePlusMinus>
        </div>
      ) : null}
    </div>
  );
};

const mapStateToProps = (state) => ({
  create: state.create,
});

export default connect(mapStateToProps, { updateCreateParams })(
  PhotovoltaicParams
);
